<template>
  <TarjetaDatos titulo="Propietario">
    <Campo2L :valor="poliza.nombrePropietario" />
    <CampoPhone :valor="poliza.telefonoPropietario" />
    <CampoEmail :valor="poliza.emailPropietario" />
    <Campo2L :valor="poliza.direccionPropietario" etiqueta="Dirección" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
